export default __webpack_public_path__ + "static/media/icon-plugin.a18d7092.svg";